import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { State } from '../../store/main';
import { mergeMap, first } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class BasicAuthInterceptor implements HttpInterceptor {
  public constructor(private store: Store<State>) {}

  public intercept<RQ = any>(
    request: HttpRequest<RQ>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    // add authorization header with jwt auth credentials if available
    return this.store.pipe(select('auth')).pipe(
      first(),
      mergeMap((authState) => {
        if (authState.isAuthenticated) {
          request = request.clone({
            setHeaders: {
              Accept: 'application/json',
              Authorization: `Bearer ${authState.accessToken}`,
            },
          });
        }
        return next.handle(request);
      }),
    );
  }
}
